import styles from "./styles/styles.module.css"

import React from 'react';
import { useNavigate } from "react-router";
import { Module } from './Module';
import parse from 'html-react-parser';
import { ApplicationRightComponent } from "components/access/ApplicationRightComponent";
import { IconPicker } from "components/layout/icons/IconPicker";
import { ResponsiveContent } from "components/layout/ResponsiveContent";

export const Dashboard = () => {
    return (
        <ApplicationRightComponent requiredApplicationRights={Module.applicationRights}>
            <DashboardContent/>
        </ApplicationRightComponent>
    )
}

const DashboardContent = () => {

    const navigate = useNavigate();

    const onClick = () => {
        navigate(Module.url);
    }

    return (
        <div className={styles.bar} onClick={onClick}>
            <div className={styles.barContent}>
                <div role="heading">{parse(Module.text)}</div>
                <div><IconPicker icon={Module.icon} size={24} /></div>
            </div>
            {
                (Module.minWidth) &&
                <ResponsiveContent minWidth={Module.minWidth}>Krever en bredde p&aring; mer enn 768px.</ResponsiveContent>
            }
        </div>
    )
}

export default Dashboard;
